import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import ChartDonut from '../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../components/charts/types/ChartColumn'
import { GET_VALIDATION_ERRORS } from '../../../queries/events'
import { formatNumber, formatDateCard } from '../../../utils/Helpers'
import { FilterEvents } from '../../../types/FilterEvents'
import { defaultDateRange, defaultFormatTimeZone } from '../../../utils/consts'

interface Bucket {
  key: string
  doc_count: number
}
const ValidationError = (): JSX.Element => {
  const { filters } = useContext(EventsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_VALIDATION_ERRORS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    let date: FilterEvents['date'] = { ...defaultDateRange }

    if (filters.date) {
      date = {
        ...filters.date,
        ...defaultFormatTimeZone
      }
    }
    getData({
      variables: { filters: { ...filters, date } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartDonutSkeleton />
  if (loading || !data) return <ChartDonutSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.eventOfferIntegrationValidatorErrorAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.eventOfferIntegrationValidatorErrorAggs.aggregations.messages
  const labels: Array<string> = []
  const series: Array<number> = []

  buckets.map((bucket: Bucket) => {
    labels.push(bucket.key)
    return series.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'validation-errors'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        let total = 0
        opts.w.globals.series.map((serie: any) => {
          total += serie
        })

        return [seriesName, ' - ', formatNumber((opts.w.globals.series[opts.seriesIndex] / total) * 100, 2), '%']
      },
      width: 233,
      height: 300
    },
    dataLabels: {
      formatter: function (value: number) {
        return `${formatNumber(value, 2)}%`
      }
    },
    tooltip: {
      y: {
        formatter: function (value: number) {
          return formatNumber(value, 0)
        }
      }
    }
  }

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Erros de validação mais comuns ({formatDateCard(filters.date?.initialDate, filters.date?.finalDate)})</Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.red} type="donut" />
  </Paper>
}

export default ValidationError
